import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 15 10",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		d: "M0 5.833h11.808L8.825 8.825 10 10l5-5-5-5-1.175 1.175 2.983 2.992H0z"
	}) })
});
export default SvgArrowRight;
